import { useState } from 'react'
import { Linking, View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Card, CardBody, CardFooter, CardHeader } from '@/src/elements/card'
import { Image } from '@/src/elements/image'
import { Typography } from '@/src/elements/text/Typography'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { storage, STORAGE_KEYS } from '@/src/general/utilities/storage/MMKVStorage'

export const PAPA_QUIZ_URL = 'https://hozana.org/web/quiz-leon-xiv/'

export const PapaQuizBlock = () => {
  const [isDismissed, setIsDismissed] = useState(
    () => storage.getItem(STORAGE_KEYS.PAPA_QUIZ_BANNER_DISMISSED) === 'true',
  )

  const dismiss = () => {
    storage.setItem(STORAGE_KEYS.PAPA_QUIZ_BANNER_DISMISSED, 'true')
    setIsDismissed(true)
  }

  const openQuiz = () => {
    void Linking.openURL(PAPA_QUIZ_URL)
    dismiss()
  }

  if (isDismissed) return null

  return (
    <View pointerEvents="box-none" className="absolute inset-x-0 bottom-0 z-[2] items-center px-4 pb-4">
      <View pointerEvents="auto" className="w-full md:max-w-5xl">
        <Card
          testID={TEST_ID.PRAYER_SPACE.PAPA_QUIZ_BLOCK}
          isBlurred
          className="!bg-leonxivfr-light/50 min-h-60 overflow-visible pl-36 md:pl-96"
        >
          <View className="absolute w-36 md:w-96 md:gap-4 h-full left-0 md:flex-row p-4 md:p-8">
            <Image source={require('@/img/leonxivfr/leonxivfr-logo.png')} radius="none" />
            <Image source={require('@/img/leonxivfr/leonxivfr-tagline.png')} radius="none" />
          </View>
          <CardHeader className="relative pl-2 pt-6 pb-4">
            <Button
              isIconOnly
              startIcon={ICON.CLOSE}
              colors="default"
              variant="light"
              contrast="low"
              testID={TEST_ID.PRAYER_SPACE.PAPA_QUIZ_CLOSE_BUTTON}
              onPress={dismiss}
              size="sm"
              className="absolute z-50 top-2 right-1.5 text-leonxivfr"
            />
            <Typography size="lg" bold className="text-leonxivfr text-left pr-10">
              Connaissez-vous vraiment le pape ?
            </Typography>
          </CardHeader>
          <CardBody className="pb-1 pl-2">
            <Typography>Répondez à 10 questions pour tester vos connaissances</Typography>
          </CardBody>
          <CardFooter className="pl-2">
            <Button
              onPress={openQuiz}
              variant="solid"
              colors="secondary"
              testID={TEST_ID.PRAYER_SPACE.PAPA_QUIZ_CONFIRM_BUTTON}
              className="bg-leonxivfr w-full"
            >
              Répondre au quiz
            </Button>
          </CardFooter>
        </Card>
      </View>
    </View>
  )
}
